"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur is an SAP Company',
    learn: {
      href: '/sap',
      text: 'Learn more'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: 'CONCUR BLOG',
      href: ''
    }, {
      text: 'GET A QUOTE',
      href: '/get-quote-form'
    }],
    selector: 'COUNTRY/REGION SELECTOR',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: 'Privacy Policy',
      href: '/privacy-policy'
    }, {
      text: 'Terms of Use',
      href: ''
    }]
  }
};